/**
 * POS-I360: the one place a PKR amount becomes an amount in the default (receipt) currency. Exact integer arithmetic
 * (paisa and rate micro-units, BigInt), rounded half up to 2 places once. The cart, its totals and the receipt all call
 * this, so the cashier and the customer see the same figure. PKR stays the charged amount everywhere.
 */
export function convertPkrToCurrency(pkr: number | string, rate: number | string): number {
  const amount = Number(pkr);
  const r = Number(rate);
  if (!isFinite(amount) || !isFinite(r) || !(r > 0)) return 0;
  const negative = amount < 0;
  const cents = BigInt(Math.round(Math.abs(amount) * 100));
  const micro = BigInt(Math.round(r * 1_000_000));
  if (micro === BigInt(0)) return 0;
  const two = BigInt(2);
  // cents * 1e6 / micro = foreign cents; (2n + d) / 2d rounds half up
  const num = cents * BigInt(1_000_000);
  const q = (num * two + micro) / (micro * two);
  const out = Number(q) / 100;
  return negative ? -out : out;
}
